<template>
  <div class="layout-wrap fillcontain">
    <header class="header-wrap">
      <div class="w">
      <div class="logo-pic">
        <img :src="logoPic" />
      </div>
      <el-menu class="nav-menu" :default-active="this.$route.name"  mode="horizontal" 	>
         <sidebar-item v-for="(menu,index) in topNavTree"  @goToRoute="upGoToRoute" :item="menu" :key="index" />
      </el-menu>
      <div class="lang-wrap">
        <span  @click="toggleLang('cn',0)" :class="{'s-active':curIndex == 0}">简</span>
        <span >/</span>
        <span  @click="toggleLang('en',1)" :class="{'s-active':curIndex == 1}">En</span>
      </div>
      </div>
    </header>
    <div class="lay-content">
      <transition name="fade-transform" mode="out-in">
        <keep-alive >
          <router-view></router-view>
        </keep-alive>
      </transition>
      <footer class="footer-wrap">
        <div class="m-wrap">
          <p class="m-title">{{ $t("footer.rights") }}</p>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import SidebarItem from "@/components/SidebarItem/SidebarItem";
import logoUrl from "@/assets/img/home/logo2.png";
import {_getLocalStore, _setLocalStore} from '@/lib/storage'
import {mapMutations,mapGetters} from 'vuex'
export default {
  data() {
    return {
      logoPic: logoUrl,
      activeIndex: "home",
      curIndex: '0',
      topNavTree: [
        { name: "home" },
        { name: "visaItems" },
        { name: "faq"},
        { name: "contacts" },
      ],
    };
  },
  components: {
    SidebarItem,
  },
  computed: {
    ...mapGetters(['getActiveIndex']),
    pageCache() {
      //页面缓存
    },
    specialPage() {
      this.activeIndex = this.$route.name;
      if (this.$route.name == "technology" || this.$route.name == "products") {
        return true;
      }
    },
  },
  methods: {
    ...mapMutations(['addMenuList']),
    upGoToRoute(item) {
      if (!item.children) {
        this.$router.push({
          name: item.name,
        });
      }
    },
    toggleLang(val,index){
      _setLocalStore('curIndex',index)
      this.curIndex = index;
      if(val == 'cn'){
        _setLocalStore('language',val)
       this.$i18n.locale = _getLocalStore('language')
       this.setCurThemeType('cnWrap')
      }else if( val == 'en'){
        _setLocalStore('language',val)
         this.$i18n.locale = _getLocalStore('language')
         this.setCurThemeType('enWrap')
      }
    }
  },
  created() {
    let result = _getLocalStore('curIndex')
    this.curIndex = result ? result : '0'
  },
  mounted() {},
  watch:{

  }
};
</script>

<style  lang="scss" scoped>
@import "layout.scss";
</style>
